import { Divider, styled, Skeleton } from '@mui/material'
import { AvatarSize } from '$common/avatar'
import { AVATAR_SIZES } from '$common/avatar/avatar-base/conf'

export const JOIN_CHANNEL_REQUEST_LIST_ITEM_HEIGHT = 72

export function JoinHallRequestListItemSkeleton() {
  return (
    <>
      <ListItemRoot>
        <ListItemContent>
          <ListItemUserInfo>
            <Skeleton
              variant="circular"
              width={AVATAR_SIZES[AvatarSize.MD]}
              height={AVATAR_SIZES[AvatarSize.MD]}
            />
            <ListItemTexts>
              <Skeleton variant="text" width={70} height={20} />
              <Skeleton variant="text" width={120} height={20} />
            </ListItemTexts>
          </ListItemUserInfo>
          <ListItemActions>
            <Skeleton
              variant="rounded"
              sx={{ borderRadius: '12px' }}
              width={40}
              height={40}
            />
            <Skeleton
              variant="rounded"
              sx={{ borderRadius: '12px' }}
              width={40}
              height={40}
            />
          </ListItemActions>
        </ListItemContent>
      </ListItemRoot>
      <Divider variant="inset" />
    </>
  )
}

const ListItemRoot = styled('div')`
  height: ${JOIN_CHANNEL_REQUEST_LIST_ITEM_HEIGHT}px;
  position: relative;
  width: 100%;
`

const ListItemContent = styled('div')`
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  pointer-events: none;
`

const ListItemUserInfo = styled('div')`
  gap: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
`

const ListItemTexts = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
`

const ListItemActions = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
  pointer-events: auto;
`
